import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.assign.js";
import Drip from '@/drip';
import KNB from '@dp/knb';
var getSSLInfoMethod = function getSSLInfoMethod() {
  if (Drip.UA.IS_MAOYAN) {
    return 'movie.getCertificateInfo';
  } else if (Drip.UA.IS_MEITUAN) {
    return 'movie.getMtCertificateInfo';
  } else {
    return 'movie.getCertificateInfo';
  }
};
export var getSSLCA = function getSSLCA() {
  return new Promise(function (resolve, reject) {
    try {
      var responseByKnb = function responseByKnb() {
        return {
          success: function success(response) {
            resolve(response ? response.certificate : '');
          },
          fail: function fail(error) {
            resolve('');
          }
        };
      };
      var method = getSSLInfoMethod();
      KNB.use("".concat(method), Object.assign({
        host: location.host
      }, responseByKnb()));
      setTimeout(function () {
        resolve('');
      }, 300);
    } catch (err) {
      resolve('');
    }
  });
};
export var canGetSSLInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!Drip.UA.IS_MAOYAN) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", true);
        case 4:
          if (!(Drip.UA.IS_MEITUAN && KNB.Semver.gte(Drip.UA.appVersion, '12.29.400'))) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return", true);
        case 8:
          return _context.abrupt("return", false);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function canGetSSLInfo() {
    return _ref.apply(this, arguments);
  };
}();
export var needFetchMtConfig = function needFetchMtConfig() {
  return Drip.UA.IS_MEITUAN && KNB.Semver.gte(Drip.UA.appVersion, '12.29.400');
};